import { render, staticRenderFns } from "./featured-brands.vue?vue&type=template&id=d8e6f478"
import script from "./featured-brands.vue?vue&type=script&lang=js"
export * from "./featured-brands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports